module.exports = __DEV__ ? require("./env.dev.js") : require("./env.prod.js")
